import { render, staticRenderFns } from "./top-rancing.vue?vue&type=template&id=54547584&"
import script from "./top-rancing.vue?vue&type=script&lang=js&"
export * from "./top-rancing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports